import React from 'react';
import { UserCheck, Target } from 'lucide-react';
import { motion } from 'framer-motion';
export const TargetAudience = () => {
  const isForYou = ['Sos psicólogo/a o terapeuta y trabajás, o querés trabajar, con pacientes con TCA.', 'Querés saber qué evaluar desde la primera consulta.', 'Te cuesta diferenciar restricción, atracones, conductas compensatorias, imagen corporal y señales de riesgo.', 'Querés tener una estructura clínica para intervenir sin reducir todo a comida o peso.', 'Buscás un sistema práctico, profesional y aplicable desde el primer día.'];
  const results = ['Entrás a la primera consulta con más claridad.', 'Diseñás un plan de tratamiento por objetivos y etapas.', 'Intervenís mejor sobre pensamientos, emociones, conductas e imagen corporal.', 'Trabajás la ambivalencia sin caer en juicio ni confrontación improductiva.', 'Cerrás el proceso con criterios de alta, prevención de recaídas y seguimiento post alta.'];
  return <section className="py-20 px-4 bg-brand-cream text-brand-teal-dark" data-id="element-128">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-gray-100" data-id="element-130">
          <div className="flex items-center gap-4 mb-8" data-id="element-131">
            <div className="bg-brand-cream p-3 rounded-full" data-id="element-132">
              <UserCheck className="w-8 h-8 text-brand-teal" data-id="element-133" />
            </div>
            <h2 className="font-serif text-2xl font-bold" data-id="element-134">
              ESTE KIT ES PARA VOS SI...
            </h2>
          </div>
          <ul className="space-y-5" data-id="element-135">
            {isForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-136">
                <div className="w-2 h-2 rounded-full bg-brand-gold mt-2.5 flex-shrink-0" data-id="element-137" />
                <span className="text-gray-700 leading-relaxed" data-id="element-138">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-brand-teal text-white p-8 md:p-10 rounded-3xl shadow-xl" data-id="element-139">
          <div className="flex items-center gap-4 mb-8" data-id="element-140">
            <div className="bg-white/10 p-3 rounded-full" data-id="element-141">
              <Target className="w-8 h-8 text-brand-gold" data-id="element-142" />
            </div>
            <h2 className="font-serif text-2xl font-bold text-brand-cream" data-id="element-143">
              EL RESULTADO:
            </h2>
          </div>
          <ul className="space-y-5" data-id="element-144">
            {results.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-145">
                <div className="w-2 h-2 rounded-full bg-brand-gold mt-2.5 flex-shrink-0" data-id="element-146" />
                <span className="text-brand-cream/90 leading-relaxed" data-id="element-147">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
};